import React from 'react';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Css from './NavItem.scss';

const navItem = props => {
  let className = 'd-none';
  if (
    props.childs !== undefined &&
    props.expanded !== undefined &&
    props.expanded
  ) {
    className = 'd-block';
  }

  return (
    <li className={Css['nav-item'] + ' nav-item'}>
      <span className={'d-block'} onClick={props.click}>
        {props.dropdown ? (
          <span className={Css.dropdown}>
            {props.title}
            {props.expanded ? (
              <FontAwesomeIcon
                icon={['fas', 'minus']}
                className={'float-right mt-1'}
              />
            ) : (
              <FontAwesomeIcon
                icon={['fas', 'plus']}
                className={'float-right mt-1'}
              />
            )}
          </span>
        ) : props.external === undefined ? (
          <Link to={props.url} onClick={props.toggle} data-goto={props.goto}>
            {props.title}
          </Link>
        ) : (
          <a href={props.url} onClick={props.toggle}>
            {props.title}
          </a>
        )}
      </span>

      {props.childs !== undefined && (
        <div className={className}>
          {props.childs.map((child, i) => (
            <div className={Css.child} key={i}>
              {child.external === undefined ? (
                <Link
                  onClick={
                    child.click !== undefined ? child.click : props.toggle
                  }
                  className={'d-block'}
                  to={child.url}
                >
                  {child.title}
                </Link>
              ) : (
                <a
                  onClick={
                    child.click !== undefined ? child.click : props.toggle
                  }
                  className={'d-block'}
                  href={child.url}
                >
                  {child.title}
                </a>
              )}
              {child.childs !== undefined &&
                child.childs.map((child2, j) => (
                  <Link
                    className={'d-block pl-3'}
                    onClick={props.toggle}
                    to={child2.url}
                    key={j}
                  >
                    {child2.title}
                  </Link>
                ))}
            </div>
          ))}
        </div>
      )}
    </li>
  );
};

export default navItem;



// WEBPACK FOOTER //
// ./src/components/Header/Mobile/NavItem/NavItem.js